import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaCircleUser, FaChevronLeft } from "react-icons/fa6";
import { BsFillShieldLockFill } from "react-icons/bs";
import { showNotification } from "../Notification/Notification";
import { toast, Bounce } from "react-toastify";

const ICON_SVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22 12c0-5.51-4.49-10-10-10S2 6.49 2 12c0 2.9 1.25 5.51 3.23 7.34 0 .01 0 .01-.01.02.1.1.22.18.32.27.06.05.11.1.17.14.18.15.38.29.57.43l.2.14c.19.13.39.25.6.36.07.04.15.09.22.13.2.11.41.21.63.3.08.04.16.08.24.11.22.09.44.17.66.24.08.03.16.06.24.08.24.07.48.13.72.19.07.02.14.04.22.05.28.06.56.1.85.13.04 0 .08.01.12.02.34.03.68.05 1.02.05.34 0 .68-.02 1.01-.05.04 0 .08-.01.12-.02.29-.03.57-.07.85-.13.07-.01.14-.04.22-.05.24-.06.49-.11.72-.19.08-.03.16-.06.24-.08.22-.08.45-.15.66-.24.08-.03.16-.07.24-.11.21-.09.42-.19.63-.3.08-.04.15-.09.22-.13.2-.12.4-.23.6-.36.07-.04.13-.09.2-.14.2-.14.39-.28.57-.43.06-.05.11-.1.17-.14.11-.09.22-.18.32-.27 0-.01 0-.01-.01-.02C20.75 17.51 22 14.9 22 12Zm-5.06 4.97c-2.71-1.82-7.15-1.82-9.88 0-.44.29-.8.63-1.1 1A8.48 8.48 0 0 1 3.5 12c0-4.69 3.81-8.5 8.5-8.5 4.69 0 8.5 3.81 8.5 8.5 0 2.32-.94 4.43-2.46 5.97-.29-.37-.66-.71-1.1-1Z"
      fill="currentColor"
    ></path>
    <path
      d="M12 6.93c-2.07 0-3.75 1.68-3.75 3.75 0 2.03 1.59 3.68 3.7 3.74h.18a3.743 3.743 0 0 0 3.62-3.74c0-2.07-1.68-3.75-3.75-3.75Z"
      fill="currentColor"
    ></path>
  </svg>
);

function InputField({ label, name, type, placeholder, value, onChange }) {
  return (
    <div className="flex flex-col gap-y-2 mt-5 first:mt-0">
      <label htmlFor={name}>{label}</label>
      <input
        required
        type={type}
        name={name}
        placeholder={placeholder}
        id={name}
        value={value}
        onChange={onChange}
        className="bg-[#22252F] rounded-lg px-4 focus:border focus:border-[#e3ff59] focus:bg-[#161920] outline-none text-base/[48px] transition-colors"
      />
    </div>
  );
}

function Divider() {
  return <div className=" h-[1px] bg-gray-800 mt-5 mx-5"></div>;
}

function AuthLinks({ isLogin, type }) {
  return (
    <div className="flex justify-between و-full mt-7">
      <div className="flex gap-x-2 items-center text-sm">
        <FaCircleUser className="w-4 h-4" />
        <Link to={type === "login" ? "/signup" : "/login"}>
          حساب کاربری ندارید؟
        </Link>
      </div>
      <div>
        <Link
          to={isLogin ? "/signup" : "/login"}
          className="flex gap-x-2 items-center text-gray-500 hover:text-[#ffd642] transition-colors group active:text-[#D4FE00] text-xs md:text-base"
        >
          {isLogin ? "ایجاد حساب کاربری" : "ورود به حساب کاربری"}
          <FaChevronLeft className="w-3 h-3 transition-transform duration-200 group-hover:-translate-x-1.5" />
        </Link>
      </div>
    </div>
  );
}

function ForgotPassword() {
  return (
    <div className="flex gap-x-1 items-center mt-5 text-gray-500">
      <BsFillShieldLockFill className="w-[18px] h-[18px] transition-transform duration-200 group-hover:-translate-x-1.5" />
      <Link
        to="/recovery"
        className="flex gap-x-2 items-center text-gray-500 hover:text-[#FFFFFF] transition-colors group active:text-[#D4FE00] text-xs md:text-base"
      >
        فراموشی کلمه عبور
        <FaChevronLeft className="w-3 h-3 transition-transform duration-200 group-hover:-translate-x-1.5" />
      </Link>
    </div>
  );
}

// لودر دایره‌ای کوچک
function SmallLoader() {
  return (
    <span
      className="inline-block align-middle ml-2"
      style={{ width: "18px", height: "18px" }}
    >
      <svg
        className="animate-spin"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        style={{ display: "inline-block" }}
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="#e3ff59"
          strokeWidth="4"
          fill="none"
        />
        <path
          className="opacity-75"
          fill="#111111"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
    </span>
  );
}

// حذف useEffect و نمایش toast فقط در submitHandler
const submitHandler = async (
  e,
  isRecovery,
  isLogin,
  email,
  password,
  dupPassword,
  setTrueEmail,
  setTruePass,
  navigate,
  setLoading
) => {
  e.preventDefault();
  setLoading(true);

  if (isRecovery) {
    // بررسی وجود ایمیل در دیتابیس برای بازیابی رمز عبور
    try {
      if (email) {
        const response = await fetch(
          "https://react-shop-7a52d-default-rtdb.firebaseio.com/users.json"
        );
        const dataObj = await response.json();
        const data = dataObj ? Object.values(dataObj) : [];
        const findedUser = data.find((user) => user.email === email);

        if (findedUser) {
          // فرض می‌کنیم ارسال ایمیل انجام شده (در واقعیت باید ایمیل ارسال شود)
          toast.success("لینک تغییر رمز عبور به ایمیل شما ارسال شد.", {
            position: "top-right",
            autoClose: 3000,
            theme: "dark",
            transition: Bounce,
          });
          await setTimeout(() => {
            navigate("/dashboard");
          }, 1500);
        } else {
          toast.error("ایمیلی با این مشخصات یافت نشد.", {
            position: "top-right",
            autoClose: 4000,
            theme: "dark",
            transition: Bounce,
          });
        }
      }
    } catch (error) {
      toast.error("خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.", {
        position: "top-right",
        autoClose: 4000,
        theme: "dark",
        transition: Bounce,
      });
    }
    setLoading(false);
    return;
  }

  if (isLogin) {
    if (email) {
      try {
        const response = await fetch(
          "https://react-shop-7a52d-default-rtdb.firebaseio.com/users.json"
        );
        const dataObj = await response.json();
        const data = dataObj ? Object.values(dataObj) : [];

        const findedUser = data.find((user) => user.email === email);
        if (findedUser) {
          if (findedUser.password === password) {
            localStorage.setItem("user", email);
            // ورود موفق
            toast.success("ورود موفقیت‌آمیز بود!", {
              position: "top-right",
              autoClose: 3000,
              theme: "dark",
              transition: Bounce,
            });
            await setTimeout(() => {
              navigate("/dashboard");
            }, 1500);
            setTrueEmail(true);
            setTruePass(true);
          } else {
            // رمز عبور اشتباه
            setTrueEmail(true);
            setTruePass(false);
            toast.error("ایمیل یا رمز عبور اشتباه است", {
              position: "top-right",
              autoClose: 4000,
              theme: "dark",
              transition: Bounce,
            });
          }
        } else {
          // ایمیل یافت نشد
          setTrueEmail(false);
          setTruePass(true);
          toast.error("ایمیل یا رمز عبور اشتباه است", {
            position: "top-right",
            autoClose: 4000,
            theme: "dark",
            transition: Bounce,
          });
        }
      } catch (error) {
        toast.error("خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.", {
          position: "top-right",
          autoClose: 4000,
          theme: "dark",
          transition: Bounce,
        });
      }
    }
    setLoading(false);
  } else {
    // ثبت نام: اول چک کن رمز و تکرار رمز یکی باشه
    if (password !== dupPassword) {
      toast.error("رمز عبور و تکرار رمز عبور یکسان نیستند.", {
        position: "top-right",
        autoClose: 4000,
        theme: "dark",
        transition: Bounce,
      });
      setLoading(false);
      return;
    }

    // گرفتن اطلاعات فرم

    // ابتدا همه کاربران قبلی را می‌گیریم تا آخرین id را پیدا کنیم
    const usersUrl =
      "https://react-shop-7a52d-default-rtdb.firebaseio.com/users.json";

    if (email && password && dupPassword) {
      try {
        // گرفتن لیست کاربران قبلی با await
        const res = await fetch(usersUrl);
        const users = await res.json();
        let lastId = 0;
        let isDuplicate = false;
        if (users) {
          // users یک آبجکت است که هر کلیدش یک کاربر است
          const usersArr = Object.values(users);
          // چک کن ایمیل تکراری نباشد
          if (usersArr.some((u) => u.email === email)) {
            isDuplicate = true;
          }
          if (usersArr.length > 0) {
            // اگر کاربری وجود داشت، بیشترین id را پیدا کن
            lastId = Math.max(...usersArr.map((u) => Number(u.id) || 0));
          }
        }

        if (isDuplicate) {
          toast.error("این ایمیل قبلا ثبت شده است.", {
            position: "top-right",
            autoClose: 4000,
            theme: "dark",
            transition: Bounce,
          });
          setLoading(false);
          return;
        }
        const newId = lastId + 1;
        // حالا کاربر جدید را ذخیره کن با await
        const response = await fetch(usersUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: newId,
            email,
            password,
          }),
        });
        const data = await response.json();
        toast.success("حساب کاربری با موفقیت ایجاد شد!", {
          position: "top-right",
          autoClose: 3000,
          theme: "dark",
          transition: Bounce,
        });
        await setTimeout(() => {
          navigate("/login");
        }, 1500);
      } catch (error) {
        toast.error("خطا در ثبت نام. لطفا دوباره تلاش کنید.", {
          position: "top-right",
          autoClose: 4000,
          theme: "dark",
          transition: Bounce,
        });
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  }
};

export default function Form({ type }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [dupPassword, setdupPassword] = useState("");
  const [trueEmail, setTrueEmail] = useState(false);
  const [truePass, setTruePass] = useState(false);
  const [loading, setLoading] = useState(false);
  const isLogin = type === "login";
  const isRecovery = type === "recovery";
  const navigate = useNavigate("");
  const location = useLocation();
  // عنوان بالای فرم بر اساس نوع
  let formTitle = "";
  if (isRecovery) {
    formTitle = "بازیابی رمز عبور";
  } else {
    formTitle = isLogin ? "ورود به حساب کاربری" : "ایجاد حساب کاربری";
  }

  // متن دکمه سابمیت بر اساس نوع
  let submitText = "";
  if (isRecovery) {
    submitText = "ارسال کد تایید";
  } else {
    submitText = isLogin ? "ورود به حساب کاربری" : "ثبت نام و ایجاد حساب";
  }

  // حذف useEffect برای جلوگیری از نمایش دوباره toast
  // نمایش toast فقط در submitHandler انجام می‌شود
  React.useEffect(() => {
    if (location.pathname === "/login") {
      if (localStorage.getItem("user")) {
        navigate("/", { replace: true });
      }
    }
  }, [location.pathname, navigate]);
  return (
    <section
      style={{ direction: "rtl" }}
      className="md:mt-[140px] mt-[90px] z-50 relative"
    >
      <div className="flex flex-col justify-center items-center text-white">
        {/* Top title */}
        <div>
          <h2 className="flex items-center gap-x-2 text-3xl font-DanaDemiBold">
            {ICON_SVG}
            {formTitle}
          </h2>
        </div>
        {/* Form Inputs */}
        <form className="p-6 bg-lightGray md:w-[400px] w-[356px] mt-5 rounded-xl border border-gray-700/50 ">
          {/* فقط ایمیل برای recovery */}
          <InputField
            label="ایمیل"
            name="email"
            type="email"
            placeholder="ایمیل خود را وارد کنید"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {/* اگر recovery نبود، بقیه اینپوت‌ها را هم نمایش بده */}
          {!isRecovery && (
            <>
              <InputField
                label="رمز عبور"
                name="password"
                type="password"
                placeholder="رمز عبور خود را وارد کنید"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {!isLogin && (
                <>
                  <InputField
                    label="تکرار رمز عبور"
                    name="repeatPassword"
                    type="password"
                    placeholder="رمز عبور خود را مجدد وارد کنید"
                    value={dupPassword}
                    onChange={(e) => setdupPassword(e.target.value)}
                  />
                  {/* قوانین و مقررات */}
                  <div className="flex gap-x-2 items-center mt-10">
                    <input
                      required
                      type="checkbox"
                      className="appearance-none w-5 h-5 rounded-lg bg-[#13151D] border border-gray-700 checked:border-[#e3ff59] checked:bg-[#e3ff59] checked:ring-2 checked:ring-[#e3ff59] focus:ring-2 focus:ring-[#e3ff59] transition-all duration-200 relative
                      before:content-[''] before:absolute before:top-1 before:left-1 before:w-3 before:h-3 before:rounded before:bg-transparent checked:before:bg-transparent
                      after:content-[''] after:absolute after:top-0.5 after:left-1.5 after:w-2 after:h-3 after:border-r-2 after:border-b-2 after:border-black after:rotate-45 after:scale-0 checked:after:scale-100 checked:after:opacity-100 after:opacity-0 after:transition-all after:duration-200   "
                    />
                    <label htmlFor="" className="text-sm">
                      <span className="text-[#e3ff59]">قوانین و مقررات</span> را
                      مطالعه کردم و قبول دارم
                    </label>
                  </div>
                </>
              )}
            </>
          )}
          {/* Submit Button */}
          <div className="mt-10 w-full">
            <button
              type="submit"
              className="inline-flex justify-center items-center btn-primary text-md px-4 rounded-lg py-2 text-black w-full"
              disabled={loading}
              onClick={(e) =>
                submitHandler(
                  e,
                  isRecovery,
                  isLogin,
                  email,
                  password,
                  dupPassword,
                  setTrueEmail,
                  setTruePass,
                  navigate,
                  setLoading
                )
              }
            >
              {submitText}
              {loading && <SmallLoader />}
            </button>
          </div>
          <Divider />
          {/* ارسال isLogin به صورت پراپ به AuthLinks */}
          <AuthLinks isLogin={isLogin} type={type} />
        </form>
        <ForgotPassword />
      </div>
    </section>
  );
}
